import { useEffect, useState, useContext } from "react";
import { api } from "../App";
import Card from "./card";
import Loading from "./loading";

const Lessons = () => {
  const { apiData } = useContext(api);
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    const data = apiData.filter((obj) => obj.category_id === 358);
    setLessons(data);
  }, [apiData]);

  useEffect(() => {
    if (lessons.length) {
      setLoading(false);
    }
  }, [lessons]);

  return loading ? (
    <Loading />
  ) : (
    <div className="api-data">
      {!!lessons.length ? (
        lessons.map((obj) => <Card obj={obj} key={obj.id} />)
      ) : (
        <p className="nothing">There is nothing coming up at this time.</p>
      )}
    </div>
  );
};

export default Lessons;
